
const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }

export const upperPlanType = (planType) => {
    const split = planType.split("_");
    return [capitalize(split[0]), capitalize(split[1])].join(" ");
}

export const full_name = (firstName, lastName) => { return firstName + " " + lastName}

export const generatePageNumbers = (totalClients, clientPerPage, pageNumbers) => {
  for(let i=1; i <= Math.ceil(totalClients/clientPerPage); i++){
    pageNumbers.push(i);
  };
  return pageNumbers;
}
